import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CustomPartDetailsTabContent } from '@/areas/parts/PartDetailsPage/components/CustomPartDetailsTabController';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/custom/details/$customPartSpecificationId/used-in')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { customPartSpecificationId } = Route.useParams();
    return <CustomPartDetailsTabContent tab={'usedIn'} specificationId={customPartSpecificationId} />;
}
